import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from './auth.service';
@Injectable({
  providedIn: 'root'
})
export class AuthGuard {

  constructor(
    private router: Router,
    private auth: AuthService
  ) { }

  canActivate() {
    const token = localStorage.getItem('access_token');

    if (token === null) {
      this.router.navigateByUrl('/sessions/signin');
      return false;
    }
    return true;
  }
}
